<template>
  <el-row :gutter="20">
    <el-col :span="3"></el-col>
    <el-col :span="18">
      <div class="block">
        <el-timeline>
          <span style="margin-left: 3rem">顯示最近50筆資料</span>
          <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index"
            :timestamp="activity.timestamp"
            style="margin-top: 2rem"
          >
            <el-card>
              <h4>{{ activity.event }}</h4>
              <pre class="note-content">{{
                processNoteByEventType(activity.event, activity.note).content
              }}</pre>
              <template
                v-if="
                  processNoteByEventType(activity.event, activity.note).source
                "
              >
                <p>
                  操作者: {{ activity.userName }} 來源:
                  {{
                    processNoteByEventType(activity.event, activity.note).source
                  }}
                </p>
              </template>
              <template v-else>
                <p>操作者: {{ activity.userName }}</p>
              </template>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-col>
    <el-col :span="3"></el-col>
  </el-row>
</template>

<script>
import Record_behavir from '../../assets/js/libs/FirebaseAPI/RecordBill'
import Driver from '../../assets/js/libs/Driver'
const record = new Record_behavir()
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      reverse: true,
      activities: [
        {
          event: '',
          note: '',
          timestamp: '',
          userName: '',
        },
      ],
    }
  },
  computed: {
    ...mapState('serviceStore', {
      vx_serviceList: 'serviceList',
    }),
  },
  async mounted() {
    let type = this.$route.query.type
    let id = this.$route.query.id
    let result = await record.getRecord(type, id)
    if (result.success) {
      let data = result.result
      console.log('data', data)
      let array = []
      for (let i = 0; i < data.length; i++) {
        array.push({
          timestamp: moment(data[i].created).format('YYYY-MM-DD HH:mm:ss'),
          event: data[i].event,
          note: data[i].note,
          userName: data[i].userName,
        })
      }
      this.activities = array
    }
  },
  methods: {
    mapService(serviceStr) {
      // 支援字串與陣列
      if (!serviceStr || (Array.isArray(serviceStr) && serviceStr.length === 0))
        return '無'
      var ids
      if (typeof serviceStr === 'string') {
        ids = serviceStr.split(',')
      } else if (Array.isArray(serviceStr)) {
        ids = serviceStr
      } else {
        return '無'
      }
      var names = ids.map(
        function (id) {
          var service = this.vx_serviceList.find(
            function (s) {
              return s.id.toString() === id.toString()
            }.bind(this),
          )
          return service ? service.name : id
        }.bind(this),
      )
      return names.join(',')
    },
    processNoteByEventType(eventType, note) {
      try {
        switch (eventType) {
          case '新增乘客資料':
          case '修改乘客資料': {
            const passengerData = JSON.parse(note)
            if (passengerData.id) {
              // 第一種格式
              return {
                content:
                  `會員名稱: ${passengerData.name || '無'}\n` +
                  `進線電話: ${passengerData.phone || '無'}\n` +
                  `聯絡電話: ${passengerData.contactPhone || '無'}\n` +
                  `乘客黑名單: ${passengerData.isWarning ? '開' : '關'}\n` +
                  `性別: ${
                    passengerData.gender === 1
                      ? '男'
                      : passengerData.gender === 0
                        ? '女'
                        : '無'
                  }\n` +
                  `上車地點1: ${passengerData.onLocation1 || '無'}\n` +
                  `上車地點2: ${passengerData.onLocation2 || '無'}\n` +
                  `上車地點3: ${passengerData.onLocation3 || '無'}\n` +
                  `上車地點4: ${passengerData.onLocation4 || '無'}\n` +
                  `上車地點5: ${passengerData.onLocation5 || '無'}\n` +
                  `上車地點6: ${passengerData.onLocation6 || '無'}\n` +
                  `上車地點7: ${passengerData.onLocation7 || '無'}\n` +
                  `上車地點8: ${passengerData.onLocation8 || '無'}\n` +
                  `上車地點9: ${passengerData.onLocation9 || '無'}\n` +
                  `上車備註: ${passengerData.commands || '無'}\n` +
                  `客服備註: ${passengerData.serviceCommand || '無'}`,
                source: passengerData.isFormPhoneHail ? '派車頁面' : '乘客資料',
              }
            } else {
              // 第二種格式
              let serviceList = passengerData.serviceList
                ? passengerData.serviceList
                    .split(',')
                    .map((id) => {
                      const service = this.vx_serviceList.find(
                        (s) => s.id.toString() === id,
                      )
                      return service ? service.name : id
                    })
                    .join(',')
                : '無'

              return {
                content:
                  `進線電話: ${passengerData.phone || '無'}\n` +
                  `聯絡電話: ${passengerData.contactPhone || '無'}\n` +
                  `上車地點1: ${passengerData.onLocation1 || '無'}\n` +
                  `服務項目: ${
                    passengerData.isFormPhoneHail ? serviceList || '無' : '無'
                  }\n` +
                  `性別: ${
                    passengerData.gender === 1
                      ? '男'
                      : passengerData.gender === 0
                        ? '女'
                        : '無'
                  }\n` +
                  `上車備註: ${passengerData.commands || '無'}\n` +
                  `客服備註: ${passengerData.serviceCommand || '無'}`,
                source: passengerData.isFormPhoneHail ? '派車頁面' : '乘客資料',
              }
            }
          }

          case '新增黑名單':
          case '編輯黑名單': {
            const blacklistData = JSON.parse(note)
            return {
              content:
                `呼號:${blacklistData.callNumber || '無'}` +
                `&&原因:${blacklistData.reason || '無'}` +
                `&&來源:${
                  blacklistData.memo === '1' ? '乘客設定' : '司機拒載'
                }`,
            }
          }
          case '移除黑名單':
            return { content: '呼號:' + note }
          case '新增司機':
          case '更新司機資料': {
            const driverData = note
            return {
              content:
                `呼號: ${driverData.call_number || '無'}\n` +
                `種類: ${Driver.getDriverType(driverData.type) || '無'}\n` +
                `姓名: ${driverData.name || '無'}\n` +
                `性別: ${driverData.gender === 0 ? '男' : '女'}\n` +
                `帳號: ${driverData.phone || '無'}\n` +
                `聯絡電話1: ${driverData.contact1 || '無'}\n` +
                `聯絡電話2: ${driverData.contact2 || '無'}\n` +
                `司機電話: ${driverData.phone || '無'}\n` +
                `電子信箱: ${driverData.email || '無'}\n` +
                `身份字號: ${driverData.identify || '無'}\n` +
                `生日: ${driverData.birthday || '無'}\n` +
                `戶籍地址: ${driverData.address || '無'}\n` +
                `通訊地址: ${driverData.resident_address || '無'}\n` +
                `營業執照: ${driverData.business_license || '無'}\n` +
                `製造車廠: ${driverData.car_brand || '無'}\n` +
                `車牌: ${driverData.licence || '無'}\n` +
                `可載座位數: ${driverData.available_seat || '無'}\n` +
                `領牌日: ${driverData.receive_car_license_date || '無'}\n` +
                `出廠日: ${driverData.car_leave_factory_date || '無'}\n` +
                `職業駕照發照日: ${
                  driverData.professional_driver_license_date || '無'
                }\n` +
                `裝錶日: ${driverData.install_taxi_meter_date || '無'}\n` +
                `司機備註: ${driverData.note || '無'}\n` +
                `客服備註: ${driverData.team_company_note || '無'}\n` +
                `服務項目: ${this.mapService(driverData.service)}\n` +
                `權限: ${Driver.getAuthorize(driverData.authorize)}`,
            }
          }

          case '調整司機權限': {
            const driverData = note
            let content = `呼號: ${driverData.call_number || '無'}\n`
            switch (driverData.authorize) {
              case 0:
                content += '權限: 正常授權\n'
                break
              case 1:
                if (
                  driverData.startSuspensionTime &&
                  driverData.suspensionUntil &&
                  !driverData.eternalCheck
                ) {
                  content += '權限: 停權\n'
                  content += `停權開始: ${driverData.startSuspensionTime}\n`
                  content += `停權結束: ${driverData.suspensionUntil}\n`
                } else {
                  content += '權限: 永久停權\n'
                }
                content += `停權原因: ${driverData.suspension_reason || '無'}\n`
                break
              case 2:
                content += '權限: 審核中\n'
                break
              default:
                content += '權限: 未知\n'
                break
            }

            return { content }
          }

          default:
            return { content: note }
        }
      } catch (error) {
        console.error('解析 note 失敗:', error)
        return { content: note }
      }
    },
  },
}
</script>

<style scoped>
.note-content {
  white-space: pre-wrap;
  word-break: break-all;
  line-height: 1.5;
  margin: 10px 0;
  background: none;
  border: none;
  padding: 0;
  font-family: inherit;
  font-size: inherit;
}
</style>



// WEBPACK FOOTER //
// src/pages/activityRecord/ActivityRecord.vue